// Configuração da página de transmissão (/ao-vivo) do SOS Aprova 2026.
// Tudo que muda durante o evento fica aqui: links do YouTube, gravações,
// materiais, e-books e a programação. Datas e horários em Brasília (-03:00).

import capaEstrategiaLH from "../assets/transmissao/ebooks/estrategia-linguagens-humanas.jpg";
import capaEstrategiaMN from "../assets/transmissao/ebooks/estrategia-matematica-natureza.jpg";
import capaApostilaoLH from "../assets/transmissao/ebooks/apostilao-linguagens-humanas.jpg";
import capaApostilaoMN from "../assets/transmissao/ebooks/apostilao-matematica-natureza.jpg";
import capaGuia from "../assets/transmissao/ebooks/guia-sos-aprova-2026.jpg";
import thumb0211 from "../assets/transmissao/thumbs/sos-dia-02-11.webp";
import thumb0311 from "../assets/transmissao/thumbs/sos-dia-03-11.webp";
import thumb0411 from "../assets/transmissao/thumbs/sos-dia-04-11.webp";
import thumb0911 from "../assets/transmissao/thumbs/sos-dia-09-11.webp";
import thumb1011 from "../assets/transmissao/thumbs/sos-dia-10-11.webp";
import thumb1111 from "../assets/transmissao/thumbs/sos-dia-11-11.webp";


export const LIVE = {
  // Força um vídeo no player fora do horário dos aulões (ID ou link). Vazio =
  // tela "SINAL EM BREVE". As lives de cada dia ficam em RECORDINGS.
  youtubeId: "",
  // Alternativa ao youtubeId: com o ID do canal, o player mostra a live
  // automaticamente durante o horário de um aulão.
  channelId: "",
  // Playlist com as gravações em ordem (1 vídeo por dia de aulão). Usada no
  // "Assistir aulas" quando o dia não tem gravação própria em RECORDINGS.
  playlistId: "",
  playlistUrl: "https://www.youtube.com/@aprovatotal/playlists",
};

// Live de cada dia (a transmissão inteira do dia, não por professor). Durante
// os aulões do dia o player e o chat mostram esta live; depois, o
// "Assistir aulas" do dia toca a mesma URL como gravação.
export const RECORDINGS = {
  "2026-11-02": "https://www.youtube.com/live/3T-hrgDvHKA",
  "2026-11-03": "https://www.youtube.com/live/dT9Vp0Ugfzs",
  "2026-11-04": "https://www.youtube.com/live/zClqc9FcmH8",
  "2026-11-07": "https://www.youtube.com/live/wfbU1uu2A8Q",
  "2026-11-09": "https://www.youtube.com/live/dYslF3XCrKo",
  "2026-11-10": "https://www.youtube.com/live/H_BhRCq4ngU",
  "2026-11-11": "https://www.youtube.com/live/BdJmMcZB8LQ",
  "2026-11-14": "https://www.youtube.com/live/BDcOvUNZudg",
};

// Material de cada dia (e-book com os slides das aulas). Os PDFs ficam em
// public/materiais. Vazio = usa DEFAULT_MATERIAL_URL.
export const DEFAULT_MATERIAL_URL = "";
export const MATERIALS = {
  "2026-11-02": "https://content.app-us1.com/ldV4B/2026/10/29/0fb3241c-c253-4101-b932-42680256c6cc.pdf",
  "2026-11-03": "https://content.app-us1.com/ldV4B/2026/11/03/36ce7bcb-eda1-4ba3-a157-fb33ee7b9bdc.pdf",
  "2026-11-04": "/materiais/sos-semana-1-dia-3.pdf",
  "2026-11-07": "",
  "2026-11-09": "",
  "2026-11-10": "",
  "2026-11-11": "",
  "2026-11-14": "",
};

// Miniatura de cada dia (handoff da transmissão, assets/thumbs). O sábado não usa.
export const THUMBS = {
  "2026-11-02": thumb0211,
  "2026-11-03": thumb0311,
  "2026-11-04": thumb0411,
  "2026-11-09": thumb0911,
  "2026-11-10": thumb1011,
  "2026-11-11": thumb1111,
};

// Guia do SOS: abre o Kit de sobrevivência, em destaque acima dos e-books.
export const GUIA = {
  title: "Operação Salva-vidas Enem",
  text: "Seu mapa de sobrevivência para a reta final: a programação, o checklist do que já fez e a FAVS para entender os erros nos simulados.",
  cover: capaGuia,
  url: "https://content.app-us1.com/ldV4B/2026/10/30/1fce7cf7-f950-416f-b128-73070e4a8fa7.pdf",
};

// Kit de sobrevivência: os 4 e-books da entrega de inscrição
// (material.aprovatotal.com.br/sos-2026-entrega-materiais-inscricao).
// Capas oficiais (sos-aprova/*capa*.png), otimizadas para web.
// vertical: capa em pé (apostilões); as demais são 16:9.
export const EBOOKS = [
  {
    title: "Estratégia para Gabaritar o Enem",
    area: "Linguagens e Humanas",
    cover: capaEstrategiaLH,
    url: "https://content.app-us1.com/ldV4B/2026/10/24/573ba931-f25f-428a-bd6d-dace69b4256c.pdf",
  },
  {
    title: "Estratégia para Gabaritar o Enem",
    area: "Matemática e Natureza",
    cover: capaEstrategiaMN,
    url: "https://content.app-us1.com/ldV4B/2026/10/24/5b03662d-f3de-49ee-b0da-8b9901f6460c.pdf",
  },
  {
    title: "Apostilão Top 1 Enem",
    area: "Linguagens e Humanas",
    cover: capaApostilaoLH,
    vertical: true,
    url: "https://content.app-us1.com/ldV4B/2026/10/21/6aa1a194-dcca-4e7f-90de-b183dcb9b6e8.pdf",
  },
  {
    title: "Apostilão Top 1 Enem",
    area: "Matemática e Natureza",
    cover: capaApostilaoMN,
    vertical: true,
    url: "https://content.app-us1.com/ldV4B/2026/10/21/b567a0fe-501e-45e5-be86-fde622b2aa06.pdf",
  },
];

export const GABARITO_ENEM = {
  // TODO: link da correção do Enem ao vivo.
  url: "https://www.youtube.com/@aprovatotal/playlists",
  liberado: false,
};

// Cada aulão dura 45 min. guest = convidado (nome em amarelo).
export const LESSON_MINUTES = 45;

export const WEEKS = [
  {
    num: "SEMANA 1",
    short: "Linguagens e Humanas",
    simulados: [
      { area: "Linguagens", open: "05/11", close: "08/11" },
      { area: "Ciências Humanas", open: "06/11", close: "08/11" },
    ],
    days: [
      { date: "2026-11-02", dow: "SEG", label: "02/11", slots: [["18h", "Dudu", "Geografia"], ["18h45", "Thiago", "Filosofia"], ["19h30", "Bruno", "História"], ["20h15", "Camila", "Literatura"]] },
      { date: "2026-11-03", dow: "TER", label: "03/11", slots: [["18h", "Alan", "História"], ["18h45", "Thiago", "Sociologia"], ["19h30", "Ricardinho", "Português"], ["20h15", "Dani", "Redação"]] },
      { date: "2026-11-04", dow: "QUA", label: "04/11", slots: [["18h", "Alan e Dudu", "História e Geografia"], ["18h45", "Dani", "Redação"], ["19h30", "Dudu", "Geografia"], ["20h15", "Ricardinho e Camila", "Português e Literatura"]] },
      {
        date: "2026-11-07",
        dow: "SÁB",
        label: "07/11",
        slots: [
          ["10h", "Luma", "Redação", true],
          ["11h", "Carol Mendonça", "Português", true],
          ["12h", "Dudu", "Geografia"],
          ["13h", "Alan", "História"],
          ["14h", "Deco Duarte", "Português e Literatura", true],
          ["15h", "Claudio Hansen", "Geopolítica e Atualidades", true],
          ["16h", "Ricardinho", "Português"],
          ["17h", "Camila", "Literatura"],
          ["18h", "Thiago", "Filosofia e Sociologia"],
        ],
      },
    ],
  },
  {
    num: "SEMANA 2",
    short: "Natureza e Matemática",
    simulados: [
      { area: "Ciências da Natureza", open: "12/11", close: "15/11" },
      { area: "Matemática", open: "13/11", close: "15/11" },
    ],
    days: [
      { date: "2026-11-09", dow: "SEG", label: "09/11", slots: [["18h", "Jubilut", "Biologia"], ["18h45", "Jubilut", "Biologia"], ["19h30", "Piu", "Matemática"], ["20h15", "Matheus", "Física"]] },
      { date: "2026-11-10", dow: "TER", label: "10/11", slots: [["18h", "Piu", "Matemática"], ["18h45", "Nilo", "Física"], ["19h30", "Ana", "Química"], ["20h15", "Naza", "Matemática"]] },
      { date: "2026-11-11", dow: "QUA", label: "11/11", slots: [["18h", "Gustavo e Ana", "Biologia e Química"], ["18h45", "Ana", "Química"], ["19h30", "Gustavo", "Biologia"], ["20h15", "Nilo", "Física"]] },
      {
        date: "2026-11-14",
        dow: "SÁB",
        label: "14/11",
        slots: [
          ["10h", "Sandro Curió", "Matemática", true],
          ["11h", "Gustavo", "Biologia"],
          ["12h", "Piu", "Matemática"],
          ["13h", "Marcelão", "Química", true],
          ["14h", "Thales Quirino", "Física", true],
          ["15h", "Jubilut", "Biologia"],
          ["16h", "Vavá", "Matemática"],
          ["17h", "Grego", "Física"],
        ],
      },
    ],
  },
];
